import { useEffect, useState } from 'react';
import { useSurveyIfEnabled } from '../hooks/useSurveyIfEnabled';
import { SurveyName } from '../surveysUuidMap';
import { fieldsSurveysBlockersSelector } from './blockersSelectors';
import { getFieldsSurveysBlockersFromSurvey } from './dialogBlockers';
import { FieldsSurveyDialog } from './dialogs/FieldsSurveyDialog';

const SURVEY_NAME = 'fieldManagerSurvey' satisfies SurveyName;

const FieldManagerSurvey = ({ allDataLoaded }: { allDataLoaded: boolean }) => {
  const [userEngaged, setUserEngaged] = useState(false);

  const surveyInfo = useSurveyIfEnabled({
    surveyName: SURVEY_NAME,
    userEngaged,
    blockersSelector: fieldsSurveysBlockersSelector,
    getBlockersFromSurvey: getFieldsSurveysBlockersFromSurvey,
  });

  // we have sufficient engagement for survey feedback after 10s spent
  // w/ this component rendered and allDataLoaded === true
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (allDataLoaded) {
        setUserEngaged(true);
      }
    }, 10 * 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [allDataLoaded]);

  return (
    <>
      {surveyInfo.survey && (
        <FieldsSurveyDialog
          open={surveyInfo.shouldViewSurvey}
          survey={surveyInfo.survey}
          viewBlockers={surveyInfo.viewBlockers}
          surveyName={SURVEY_NAME}
        />
      )}
    </>
  );
};

export { FieldManagerSurvey };
